import { useQuery } from '@tanstack/react-query';
import type { Audit, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useAudits(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['audits', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<Audit>>(`/v1/audits?${params.toString()}`),
  });
}
